import React from 'react';
import { Skeleton, Typography } from '@mui/material';
import { showFields } from 'src/common/hooks/useSampleDetails';

const SECTION_COUNT = 3;
const FIELDS_PER_SECTION = showFields.length / SECTION_COUNT;

const PreloaderSkeleton = () => {
  return (<>
    {Array.from({ length: SECTION_COUNT }).map((_, sectionIndex) => (
    <div key={sectionIndex}>
      <Typography
        variant="h5"
        color="black"
        paragraph={false}
        className="sample-details-section-header"
      >
        <Skeleton width="40%" />
      </Typography>
      <div className="sample-details-content">
        {Array.from({ length: FIELDS_PER_SECTION }).map((_, fieldIndex) => (
          <React.Fragment key={fieldIndex}>
            <Skeleton width={500} />
            <Skeleton width="80%" />
          </React.Fragment>
        ))}
      </div>
    </div>
  ))}
  </>)
}

export default PreloaderSkeleton;

